import type { ComponentProps } from "react";
import { TextField } from "@apac/form-ui";

export const PassportNumberField = (
  props: ComponentProps<typeof TextField>
) => <TextField {...props} />;
